import { useAtom } from 'jotai';
import { getAppStore } from '../../../store/appStore';
import { useCurrencies } from '../../../hooks/useCurrencies';
import {
  currencyFilterState,
  currentTenantState,
} from '../../../store/global.store';

export const useDashboardCurrencyFilter = () => {
  const currentTenant = getAppStore().get(currentTenantState);
  const [currency, setCurrency] = useAtom(currencyFilterState);
  const { defaultCurrency } = useCurrencies({ enabled: !!currentTenant?.id });

  return {
    currency: currency || defaultCurrency,
    setCurrency,
  };
};
